import { render, staticRenderFns } from "./ex-company-details.vue?vue&type=template&id=0d12ed20&scoped=true&"
import script from "./ex-company-details.vue?vue&type=script&lang=js&"
export * from "./ex-company-details.vue?vue&type=script&lang=js&"
import style0 from "./ex-company-details.vue?vue&type=style&index=0&id=0d12ed20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12ed20",
  null
  
)

export default component.exports